import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import AdminLeftMenu from './backend/AdminLeftMenu';
import { ToastContainer } from 'react-toastify';
import { useAuth } from '../contexts/AuthContext';
import FirestoreUserService from '../services/firestoreUserService';
import FirebaseAuthService from '../services/firebaseAuthService';
import toaster from '../helpers/toaster';
import { Link, useOutletContext } from "react-router-dom";


const Profile = () => {
  const [userData] = useOutletContext();
  const { currentUser } = useAuth();
  const firestoreUserService = new FirestoreUserService();
  const firebaseAuth = new FirebaseAuthService();
  const { register, handleSubmit, getValues, setValue, formState: { errors } } = useForm();
  const {
    register: register2,
    formState: { errors: errors2 },
    handleSubmit: handleSubmit2,
    getValues: getValues2
  } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState("");
  const [images, setImages] = useState("");
  const hiddenFileInput = React.useRef(null);

  // Helper function to get proper avatar URL
  const getAvatarUrl = (imageUrl) => {
    console.log('Profile getAvatarUrl - input:', imageUrl);
    
    if (!imageUrl) {
      console.log('Profile getAvatarUrl - no imageUrl, returning default');
      return "/images/profile.png";
    }
    
    let url = imageUrl;
    
    // Handle Google profile images - resize for profile page
    if (url.includes('googleusercontent.com') && url.includes('=s96-c')) {
      url = url.replace('=s96-c', '=s200-c'); // Larger for profile page
      console.log('Profile getAvatarUrl - resized Google URL:', url);
    } else if (url.includes('googleusercontent.com')) {
      console.log('Profile getAvatarUrl - Google URL but no =s96-c pattern:', url);
    }
    
    // Check if it's a valid URL
    if (url.startsWith('blob:') || url.startsWith('http')) {
      console.log('Profile getAvatarUrl - returning valid URL:', url);
      return url;
    }
    
    console.log('Profile getAvatarUrl - invalid URL, returning default');
    return "/images/profile.png";
  };

  useEffect(() => {
    if (userData) {
      setName(userData.name);
      console.log('Profile - userData.images:', userData.images);
      // Always set images, even if empty, but handle it in getAvatarUrl
      setImages(userData.images || '');
      const fields = ['first_name', 'last_name', 'email', 'phone_no'];
      fields.forEach(field => setValue(field, userData[field]));
    }
  }, [userData, setValue]);

  const handleClick = event => {
    hiddenFileInput.current.click();
  };

  const handleChange = event => {
    // For Firebase users, image upload would require Firebase Storage
    // This is a simplified version showing local preview
    try {
      const file = hiddenFileInput.current.files[0];
      if (file) {
        // Create a local URL for preview (temporary)
        const imageUrl = URL.createObjectURL(file);
        setImages(imageUrl);
        localStorage.setItem('user_image', imageUrl);
        new toaster().successMessage("Image preview updated! Full upload requires Firebase Storage setup.");
        
        // In a full Firebase implementation, you would:
        // 1. Upload to Firebase Storage
        // 2. Get the download URL
        // 3. Update the user's photoURL in Firebase Auth
      }
    } catch (error) {
      new toaster().errorMessage("Failed to update image. Please try again.");
      console.error("Image upload error:", error);
    }
  };

  async function updateProfile(data, e) {
    setIsLoading(!isLoading);
    
    try {
      if (currentUser) {
        // Update Firestore user document
        const profileData = {
          firstName: data.first_name,
          lastName: data.last_name,
          displayName: `${data.first_name} ${data.last_name}`,
          phoneNumber: data.phone_no
        };

        const firestoreResult = await firestoreUserService.updateUserProfile(currentUser.email, profileData);
        
        if (firestoreResult.success) {
          // Update local state
          setName(`${data.first_name} ${data.last_name}`);
          localStorage.setItem('user_name', `${data.first_name} ${data.last_name}`);
          
          // Update form values
          setValue('first_name', data.first_name);
          setValue('last_name', data.last_name);
          setValue('email', data.email);
          setValue('phone_no', data.phone_no);
          
          new toaster().successMessage("Profile updated successfully!");
        } else {
          new toaster().errorMessage("Failed to update profile in database. Please try again.");
        }
      }
      
      setIsLoading(false);
      
    } catch (error) {
      setIsLoading(false);
      new toaster().errorMessage("Failed to update profile. Please try again.");
      console.error("Profile update error:", error);
        }
  };

  async function changepassword(data, e) {
    setIsLoading(true);
    const result = await firebaseAuth.updatePassword(data.password);
    setIsLoading(false);

    if (result.success) {
      new toaster().successMessage(result.message);
      e.target.reset();
    } else {
      new toaster().errorMessage(result.message);
    }
  };


  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <ToastContainer />
      <div className="offcanvas offcanvas-start" id="demo">
        <AdminLeftMenu />
      </div>
      <div className="rightpane">
        <div className="container">
          <div className='row'>
            <div className='col-md-4'>
              <div className='schedule-boxleft profileleftbox'>
                <div className='propicbox'>
                  {/* <p>{images}</p> */}
                  {/* <img src="\images\profilePic.png" width={'135'} alt='' /> */}
                  <img 
                    key={userData?.images || images} // Force re-render when image changes
                    src={getAvatarUrl(userData?.images || images)} 
                    width={'135'} 
                    alt='' 
                    onError={(e) => {
                      e.target.src = "/images/profile.png";
                    }}
                    onLoad={() => {
                      console.log('Profile image loaded successfully:', getAvatarUrl(userData?.images || images));
                    }}
                  />
                </div>
                <h3>{(name) ? name : ''}</h3>
                <p>{currentUser ? currentUser.email : ''}</p>
                <div className='profileboxfooter'>
                  <Link to='#' onClick={handleClick}>Upload Picture</Link>
                  <input
                    type="file"
                    ref={hiddenFileInput}
                    onChange={handleChange}
                    style={{ display: 'none' }}
                  />
                </div>
              </div>
            </div>
            <div className='col-md-8'>
              <div className="schedule-boxleft prorightform">
                <div className='prorightform hdr'>
                  <h3>Profile</h3>
                  <p>The information can be edited</p>
                </div>
                <div className='prorightform bdy'>
                  <form onSubmit={handleSubmit(updateProfile)}>
                    <div class="row">
                      <div class="col">
                        <input type="text" class="form-control"
                          {...register("first_name", {
                            required: "First Name is required"
                          })}
                          placeholder="First Name*"
                          name="first_name"
                          id="first_name"
                        />
                        {errors.first_name ? (
                          <>
                            {errors.first_name.type === "required" && (
                              <p className="errorMessage">
                                {errors.first_name.message}
                              </p>
                            )}
                          </>
                        ) : null}
                      </div>
                      <div class="col">
                        <input type="text" class="form-control"
                          {...register("last_name", {
                            required: "Last Name is required"
                          })}
                          placeholder="Last Name*"
                          name="last_name"
                          id="last_name"
                        />
                        {errors.last_name ? (
                          <>
                            {errors.last_name.type === "required" && (
                              <p className="errorMessage">
                                {errors.last_name.message}
                              </p>
                            )}
                          </>
                        ) : null}
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col">
                        <input type="email" class="form-control"
                          {...register("email", {
                            required: "Email is required",
                            pattern: {
                              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                              message: "Email is invalid"
                            }
                          })}
                          placeholder="Email*"
                          name="email"
                        />
                        <span className="inpicrgt"><i className='fa fa-envelope'></i></span>
                        {errors.email ? (
                          <>
                            {errors.email.type === "required" && (
                              <p className="errorMessage">
                                {errors.email.message}
                              </p>
                            )}
                          </>
                        ) : null}
                      </div>
                      <div class="col">
                        <input type="number" class="form-control"
                          placeholder="Phone Number"
                          name="phone_no"
                          {...register("phone_no", {
                            required: "Phone is required"
                          })} />
                        {errors.phone_no ? (
                          <>
                            {errors.phone_no.type === "required" && (
                              <p className="errorMessage">
                                {errors.phone_no.message}
                              </p>
                            )}
                          </>
                        ) : null}
                      </div>
                    </div>
                    <div className='prorightform ftr  mt-4'>
                      <input type='submit' disabled={isLoading} className='btn btn-primary' value='Save Changes'></input>
                    </div>
                  </form>
                </div>
              </div>
              <div className="schedule-boxleft prorightform mt-5">
                <div className='prorightform hdr'>
                  <h3>Change Password</h3>
                  <p>It's a good idea to use a strong password that you're not using elsewhere</p>
                </div>
                <div className='prorightform bdy'>
                  <form onSubmit={handleSubmit2(changepassword)} >
                    <div class="row justify-content-center gap-4">
                      <div class="col-6">
                        <div class="position-relative">
                          <input type="password"
                            class="form-control"
                            {...register2("old_password", {
                              required: "old_password is required"
                            })}
                            placeholder="Current Password" name='old_password'
                          />
                          <span className="inpicrgtpws old-pass"><i className='fa fa-lock'></i></span>
                        </div>
                        {errors2.old_password ? (
                          <>
                            {errors2.old_password.type === "required" && (
                              <p className="errorMessage">
                                {errors2.old_password.message}
                              </p>
                            )}
                          </>
                        ) : null}
                      </div>
                      <div class="col-6">
                        <input type="password"
                          class="form-control"
                          placeholder="New Password"
                          name="password"
                          {...register2("password", {
                            required: "New password is required"
                          })}
                          autocomplete="off"
                        />
                        {errors2.password ? (
                          <>
                            {errors2.password.type === "required" && (
                              <p className="errorMessage">
                                {errors2.password.message}
                              </p>
                            )}
                          </>
                        ) : null}
                      </div>
                      <div class="col-6">
                        <input type="password"
                          class="form-control"
                          placeholder="Re-Type New"
                          name="confirm_password"
                          {...register2("confirm_password", {
                            required: "Please confirm password!",
                            validate: {
                              matchesPreviousPassword: (value) => {
                                const { password } = getValues2();
                                return password === value || "Passwords should match!";
                              }
                            }
                          })}
                          autocomplete="off"
                        />
                        {errors2.confirm_password && (
                          <p className="errorMessage">
                            {errors2.confirm_password.message}
                          </p>
                        )}
                      </div>
                      <div className='prorightform ftr'>
                        <button className='btn btn-primary' type="submit">Update Password</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
};

export default Profile;